import { useTranslation } from 'react-i18next';

import styles from '../ListCalendar.module.scss';

interface Props {
  onBookStay?: () => void;
}

const FreeWeek = ({ onBookStay }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.freeWeek}>
      <span>
        {t('planning.listView.freeWeek', { defaultValue: 'Maison libre toute la semaine' })}
      </span>
      {onBookStay && (
        <button className={styles.freeWeekLink} onClick={onBookStay} type="button">
          {t('planning.listView.bookStay', { defaultValue: 'réserver un séjour' })}
        </button>
      )}
    </div>
  );
};

export default FreeWeek;
